var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_star_solid",
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.87,
    height: 8.565,
    viewBox: "0 0 9.87 8.565",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_star_solid-2",
    "data-name": "Icon_star_solid"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M.44,3.119l2.2-.4A.55.55,0,0,0,3,2.481L4.463.244a.579.579,0,0,1,.945,0L6.869,2.481a.55.55,0,0,0,.363.234l2.2.4a.484.484,0,0,1,.282.837L7.884,5.634a.468.468,0,0,0-.148.446L8.147,7.97a.538.538,0,0,1-.787.54l-2.178-1a.6.6,0,0,0-.5,0l-2.178,1a.538.538,0,0,1-.787-.54L2.134,6.08a.468.468,0,0,0-.148-.446L.159,3.955A.484.484,0,0,1,.44,3.119Z",
    transform: "translate(0 0)",
    fill: "#e4001a"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.a58d69db81d8ac9274d64837e908c131.svg";
export { ForwardRef as ReactComponent };